import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ImpactRedirectType } from '../../Models/Domains/Impact/ImpactRedirectType';

declare var IS_RUNNING_IN_APP_POOL;

export class ImpactClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(clAccountId: string, redirectType: ImpactRedirectType): Promise<string, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Impact/Impact/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { clAccountId: clAccountId, redirectType: redirectType }

    return AjaxWrapper.get<string, any>(url, data);
  }
}

